//记得在 src\components\lang\zhLoad.js 里面添加对象
const bestPractices = {
  excellentCaseId: '案例ID',
  caseName:'案例名称',
  commentCount: '评论数量',
  likeCount: '点赞数量',
  viewCount: '浏览数量',
  caseDate: '有效期',
  activeOffName: '状态',
  homePushFlag: '首页推送',
  creator: '创建人',
  createTime: '创建时间',
  caseBeginDate: '开始时间',
  caseEndDate: '结束时间',
  caseDesc: '案例详情',
  alwaysFlag: '长期',
  caseImage: '案例图片',
  activeOff: '是否有效',
  msg: {}
};
export default bestPractices



// WEBPACK FOOTER //
// ./src/page/case/bestPractices/lang/bestPractices.zh.js